module.exports = __webpack_public_path__ + "img/money-project.d7bba5bc.svg";